var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "emd-container _highlight_header no-border" },
    [
      _c("div", { staticClass: "emd-container__header headerMobile" }, [
        _c("div", { staticClass: "eu-pa_2" }, [
          _c(
            "div",
            { staticClass: "eu-flex eu-mb_3" },
            [
              _c("div", { staticClass: "emd-text _size_default" }, [
                _vm._v(
                  " " + _vm._s(_vm.$t("charge.detail.recipients.title")) + " "
                ),
              ]),
              _c(
                "router-link",
                {
                  staticClass: "emd-link _color_secondary",
                  attrs: {
                    to: {
                      name: "recipientsDetail",
                      params: { id: _vm.idRecipient },
                    },
                    exact: "",
                  },
                },
                [
                  _c(
                    "span",
                    { staticClass: "emd-text _size_default _type_caption" },
                    [_vm._v("   " + _vm._s(_vm.name) + " ")]
                  ),
                ]
              ),
            ],
            1
          ),
          _c("div", { staticClass: "eu-flex eu-fluid_custom_tag" }, [
            _vm.liable
              ? _c("div", { staticClass: "contentTag" }, [
                  _c("span", { staticClass: "emd-badge tag" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "charge.detail.recipients.responsability-chargeback"
                        )
                      )
                    ),
                  ]),
                ])
              : _vm._e(),
            _vm.chargeProcessingFee
              ? _c("div", { staticClass: "contentTag" }, [
                  _c("span", { staticClass: "emd-badge tag" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t("charge.detail.recipients.responsability-MDR")
                      )
                    ),
                  ]),
                ])
              : _vm._e(),
          ]),
        ]),
        _c("div", { staticClass: "eu-mr_5 desktopRow" }, [
          _vm.netAmount
            ? _c(
                "div",
                {
                  staticClass: "emd-text totalLiquid",
                  attrs: { id: `netAmount-${_vm.idRecipient}` },
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("charge.detail.recipients.nets-amount")) +
                      " "
                  ),
                  _c("span", { staticClass: "emd-text _type_caption" }, [
                    _vm._v(_vm._s(_vm.netAmount)),
                  ]),
                ]
              )
            : _vm._e(),
          _c("div", { staticClass: "emd-text sizeRuleSplit" }, [
            _vm._v(
              " " + _vm._s(_vm.$t("charge.detail.recipients.rule-split")) + " "
            ),
            _c(
              "span",
              { staticClass: "emd-text sizeRuleSplit _type_caption" },
              [_vm._v(_vm._s(_vm.amount))]
            ),
          ]),
        ]),
        _c("div", { staticClass: "eu-flex mobileRow" }, [
          _vm.netAmount
            ? _c("div", { staticClass: "eu-ml_2 eu-mr_4" }, [
                _c(
                  "div",
                  {
                    staticClass: "emd-text _color_subtle _type_caption eu-mb_1",
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("charge.detail.recipients.nets-amount")) +
                        " "
                    ),
                  ]
                ),
                _c("span", { staticClass: "emd-text" }, [
                  _vm._v(_vm._s(_vm.netAmount)),
                ]),
              ])
            : _vm._e(),
          _c("div", { class: !_vm.netAmount && "eu-ml_2" }, [
            _c(
              "div",
              { staticClass: "emd-text _color_subtle _type_caption eu-mb_1" },
              [
                _vm._v(
                  " " +
                    _vm._s(_vm.$t("charge.detail.recipients.rule-split")) +
                    " "
                ),
              ]
            ),
            _c("span", { staticClass: "emd-text _size_default" }, [
              _vm._v(_vm._s(_vm.amount)),
            ]),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }